 
import React from "react";
import { Page, Text, View, Image, StyleSheet } from "@react-pdf/renderer";
import { PDF_PAGE } from "../../constants/pdfSizes";
 
import defaultBg from "../../assets/transportBg.jpg";

const styles = StyleSheet.create({
  page: {
    width: PDF_PAGE.width,
    height: PDF_PAGE.height,
    backgroundColor: "#000",
    position: "relative",
  },
  background: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(55,46,112,0.8)",
  },
  container: {
    flex: 1,
    padding: 0, 
  },
  headerIcon: {
    width: 40,
    height: 32,
    alignSelf: "center",
    marginBottom: 10,
    marginTop: 20,
  },
  title: {
    fontFamily: "Montserrat",
    fontSize: 44,
    textAlign: "center",
    color: "#fff",
    fontWeight: "medium",
    marginBottom: 0,
  },
  subtitle: {
    fontFamily: "Montserrat",
    fontSize: 20,
    textAlign: "center",
    color: "#fff",
    marginBottom: 10,
  },
  contentRow: {
    flexDirection: "row",
    gap: 20,
    alignItems: "flex-start",
    width: "100%",
  },
  vanImage: {
    width: 200,
    height: 140,
    objectFit: "contain",
    borderRadius: 8,
  },
  starIcon: {
    width: 26,
    height: 24,
    marginRight: 6,
  },
  detailsBox: {
    flex: 1,
    backgroundColor: "rgba(51,46,79,0.56)",
    padding: 20,
    borderRadius: 8,
  },
  detailRow: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    marginBottom: 15,
    textAlign: "left",
  },
  detailColumns: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 20,
  },
  detailCol: {
    flex: 1,
  },
  detailLabel: {
    fontSize: 14,
    color: "#fff",
    textAlign: "left",
    width: "50%",
    flex: 1,
    fontFamily: "Montserrat",
  },
  detailValue: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#fff",
    textAlign: "left",
    width: "50%",
    flex: 1,
    fontFamily: "Montserrat",
  },
  pointsWrapper: {
    marginTop: 20,
  },
  pointRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
    flexShrink: 0,  
  },
  pointIcon: {
    width: 20,
    height: 20,
    marginRight: 8,
    objectFit: "contain",
    flexShrink: 0,  
  },
  pointText: {
    fontSize: 12,
    color: "#fff",
    flexShrink: 0,  
    flexWrap: "wrap",  
  },
  steeringIcon: {
    width: 80,
    height: 80,
    marginLeft: 20,
    objectFit: "contain",
  },

  timelineWrapper: {},
  timelineRow: {
    flexDirection: "row",
    justifyContent: "flex-start",
    gap: 70,
    paddingLeft: 20,
    paddingRight: 20,
  },
 
  firstColumn: {
    maxWidth: "40%", 
  },
  firstDetailRow: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 8,
  },
  firstIconWrapper: {
    width: 47,
    height: 47,
    marginRight: 8,
    borderRadius: 47,
    backgroundColor: "white",
    alignItems: "center",
    justifyContent: "center",
    maxHeight: 47,
    maxWidth: 47,
  },
  firstTimelineIcon: {
    width: 30,
    height: 24,
  },
  firstDetailLabel: {
    fontSize: 16,
    color: "white",
  },

 
  secondColumn: {
    maxWidth: "40%", 
  },
  secondDetailRow: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 8,
  },
  secondIconWrapper: {
    width: 24,
    height: 24,
    marginRight: 8,
  },
  secondTimelineIcon: {
    width: 24,
    height: 24,
    resizeMode: "contain",
  },
  secondDetailLabel: {
    fontSize: 14,
  },
});

const TransportSlide = ({
  bg,
  title,
  subtitle,
  icon,
  vehicleImg,
  vanImage,
  starIcon,
  details = {},
  points = [],
  fixedIcon,
  steeringIcon,
}) => {
  const defaultBgImage = bg || defaultBg;

  return (
    <Page
      size={{ width: PDF_PAGE.width, height: PDF_PAGE.height }}
      style={styles.page}
    >
      <Image src={defaultBgImage} style={styles.background} />
      <View style={styles.overlay} />

      <View style={styles.container}>
        {/* Top Section */}
        {icon && <Image src={icon} style={styles.headerIcon} />}
        <Text style={styles.title}>{title || "TRANSPORTATION"} </Text>
        <Text style={styles.subtitle}>
          {subtitle || "Not Just A Destination"}
        </Text>

        {/* Middle Section */}
        <View style={styles.contentRow}>
          {vanImage && <Image src={vanImage} style={styles.vanImage} />}
          <View style={styles.detailsBox}>
            <View style={styles.detailColumns}>
              <View style={styles.detailCol}>
                <View style={styles.detailRow}>
                  {starIcon && <Image src={starIcon} style={styles.starIcon} />}
                  <Text style={styles.detailLabel}>Type of Vehicle</Text>
                  <Text style={styles.detailValue}>
                    {details.vehicleType || "Van"}
                  </Text>
                </View>
                <View style={styles.detailRow}>
                  {starIcon && <Image src={starIcon} style={styles.starIcon} />}
                  <Text style={styles.detailLabel}>Model</Text>
                  <Text style={styles.detailValue}>
                    {details.model || "KDH Flat Roof"}
                  </Text>
                </View>
                <View style={[styles.detailRow, { marginBottom: 0 }]}>
                  {starIcon && <Image src={starIcon} style={styles.starIcon} />}
                  <Text style={styles.detailLabel}>Air Conditioned</Text>
                  <Text style={styles.detailValue}>
                    {details.airConditioned || "Yes"}
                  </Text>
                </View>
              </View>
              <View style={styles.detailCol}>
                <View style={styles.detailRow}>
                  {starIcon && <Image src={starIcon} style={styles.starIcon} />}
                  <Text style={styles.detailLabel}>Max Passengers</Text>
                  <Text style={styles.detailValue}>
                    {details.maxPassengers || "05"}
                  </Text>
                </View>
                <View style={styles.detailRow}>
                  {starIcon && <Image src={starIcon} style={styles.starIcon} />}
                  <Text style={styles.detailLabel}>Max Luggage</Text>
                  <Text style={styles.detailValue}>
                    {details.maxLuggage || "05"}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>

        {/* Bottom Section */}
        <View style={styles.timelineWrapper}>
          <View style={styles.timelineRow}>
            {/* First Column */}
            <View style={styles.firstColumn}>
              {points.slice(0, 3).map((point, idx) => (
                <View key={idx} style={styles.firstDetailRow}>
                  <View style={styles.firstIconWrapper}>
                    {fixedIcon && (
                      <Image
                        source={{ uri: fixedIcon }}
                        style={styles.firstTimelineIcon}
                      />
                    )}
                  </View>
                  <Text style={styles.firstDetailLabel}>{point.text}</Text>
                </View>
              ))}
            </View>

            {/* Second Column */}
            <View style={styles.secondColumn}>
              {points.slice(3, 6).map((point, idx) => (
                <View key={idx + 3} style={styles.secondDetailRow}>
                  <View style={styles.firstIconWrapper}>
                    {fixedIcon && (
                      <Image
                        source={{ uri: fixedIcon }}
                        style={styles.firstTimelineIcon}
                      />
                    )}
                  </View>
                  <Text style={[styles.firstDetailLabel, { paddingRight: 15 }]}>
                    {typeof point === "string" ? point : point?.text || ""}
                  </Text>
                </View>
              ))}
            </View>
          </View>
        </View>

        {/* <View style={styles.timelineWrapper}>
        {points.map((point, idx) => (
           <View style={styles.detailCol}>
          <View key={idx} style={styles.detailRow}>
            <View style={styles.iconWrapper}>
              {fixedIcon && (
                <Image src={fixedIcon} style={styles.timelineIcon} />
              )}
            </View>
            <Text style={styles.detailLabel}>{point.text}</Text>
          </View>
          </View>
        ))}
      </View> */}
      </View>
    </Page>
  );
};

export default TransportSlide;
